import { Typography } from "@mui/material";

import styles from "./MaintenanceBanner.module.scss";
import { STATIC_IMAGES } from "@/helpers/staticImages";

const MaintenanceBanner = () => {
  return (
    <div className={`container ${styles.maintenance}`}>
      <div className={styles.inner}>
        <div className={styles.imageBox}>
          <img
            src={STATIC_IMAGES.maintenance}
            alt="Info"
            className="img-fluid"
          />
        </div>
        <Typography variant="h2" className={styles.heading}>
          Good things are on the way
        </Typography>

        <Typography
          variant="caption"
          component="p"
          className={styles.description}
        >
          Our site is undergoing scheduled maintenance and will be back shortly.
          <br />
          This will not affect your live ads—everything will continue running as
          usual. During this time we'll be rolling out updates to make the
          platform more efficient for your local marketing.
        </Typography>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
